import axios from '@/axios'
import Vue from 'vue'

const state = {
  alerts: [],
  dismissedAlerts: []
};

const actions = {
  fetchAlerts({ commit, state }) {
    return axios.get('alerts')
      .then((r) => {
        //on success when alerts change
        if (r.data.success && JSON.stringify(r.data.alerts) !== JSON.stringify(state.alerts)) {
          commit('SAVE_ALERTS', r.data.alerts)
        }
      })
  },
  dismissAlert({ commit }, payload) {
    commit('DISMISS_ALERT', payload)
  },
  clearDismissedAlerts({ commit }) {
    commit('CLEAR_DISMISSED_ALERTS')
  }
};

const mutations = {
  SAVE_ALERTS(state, messages) {
    Vue.set(state, 'alerts', messages);
  },
  DISMISS_ALERT(state, id) {
    state.dismissedAlerts.push(id)
  },
  CLEAR_DISMISSED_ALERTS(state) {
    Vue.set(state, 'dismissedAlerts', []);
  }
};

export default {
  state,
  actions,
  mutations
}
